import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@e2n/ui/v2';

import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function DeleteFristenDialog() {
  const { setOpenDeleteDialog, openDeleteDialog, fristIndex } =
    useFristenContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const handleDelete = () => {
    form.removeFieldValue(`anstellungsverhaeltnis.fristen`, fristIndex);
    toast({
      title: t(
        'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.message',
      ),
    });
    setOpenDeleteDialog(false);
  };
  return (
    <Dialog
      open={openDeleteDialog}
      onOpenChange={(open) => setOpenDeleteDialog(open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.title',
            )}
          </DialogTitle>
          <DialogDescription>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.description',
            )}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant={'secondary-blue'}
            onClick={() => setOpenDeleteDialog(false)}>
            {t('actions.abbrechen')}
          </Button>
          <Button onClick={handleDelete}>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.buttonLabel',
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
